var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 6,
    width: 7.48528,
    height: 7.48528,
    rx: 0.5,
    transform: "rotate(-45 0.707107 6)",
    fill: "white",
    stroke: "#63666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondWhite);
export default __webpack_public_path__ + "static/media/diamondWhite.7ded29dee92a5038c87dd7bf9befb0af.svg";
export { ForwardRef as ReactComponent };